const DUMMY_DATA = [
    { valuation: 4182, percentValue: Math.random(), bookingDate: '2015-07-01' },
    { valuation: 4182, percentValue: Math.random(), bookingDate: '2015-08-01' },
    { valuation: 4182, percentValue: Math.random(), bookingDate: '2015-09-01' },
    {
        valuation: 10102,
        percentValue: Math.random(),
        bookingDate: '2015-10-01',
    },
    {
        valuation: 10102,
        percentValue: Math.random(),
        bookingDate: '2015-11-01',
    },
    {
        valuation: 10052,
        percentValue: Math.random(),
        bookingDate: '2015-12-01',
    },
    {
        valuation: 10252,
        percentValue: Math.random(),
        bookingDate: '2016-01-01',
    },
    {
        valuation: 10352,
        percentValue: Math.random(),
        bookingDate: '2016-02-01',
    },
    {
        valuation: 10052,
        percentValue: Math.random(),
        bookingDate: '2016-03-01',
    },
    {
        valuation: 10152,
        percentValue: Math.random(),
        bookingDate: '2016-04-01',
    },
    {
        valuation: 20323,
        percentValue: Math.random(),
        bookingDate: '2016-05-01',
    },
    {
        valuation: 20202,
        percentValue: Math.random(),
        bookingDate: '2016-06-01',
    },
    {
        valuation: 20333,
        percentValue: Math.random(),
        bookingDate: '2016-07-01',
    },
    {
        valuation: 20334,
        percentValue: Math.random(),
        bookingDate: '2016-08-01',
    },
    {
        valuation: 13152,
        percentValue: Math.random(),
        bookingDate: '2016-09-01',
    },
    {
        valuation: 12152,
        percentValue: Math.random(),
        bookingDate: '2016-10-01',
    },
    {
        valuation: 24334,
        percentValue: Math.random(),
        bookingDate: '2016-11-01',
    },
    {
        valuation: 25334,
        percentValue: Math.random(),
        bookingDate: '2016-12-01',
    },
    {
        valuation: 25334,
        percentValue: Math.random(),
        bookingDate: '2017-01-01',
    },
    {
        valuation: 25334,
        percentValue: Math.random(),
        bookingDate: '2017-02-01',
    },
    {
        valuation: 24334,
        percentValue: Math.random(),
        bookingDate: '2017-03-01',
    },
    {
        valuation: 23334,
        percentValue: Math.random(),
        bookingDate: '2017-04-01',
    },
    {
        valuation: 30101,
        percentValue: Math.random(),
        bookingDate: '2017-05-01',
    },
    {
        valuation: 40123,
        percentValue: Math.random(),
        bookingDate: '2017-06-01',
    },
    {
        valuation: 50132,
        percentValue: Math.random(),
        bookingDate: '2017-07-01',
    },
    {
        valuation: 60123,
        percentValue: Math.random(),
        bookingDate: '2017-08-01',
    },
    {
        valuation: 70123,
        percentValue: Math.random(),
        bookingDate: '2017-09-01',
    },
    {
        valuation: 80123,
        percentValue: Math.random(),
        bookingDate: '2017-10-01',
    },
    {
        valuation: 90122,
        percentValue: Math.random(),
        bookingDate: '2017-11-01',
    },
    {
        valuation: 95016,
        percentValue: Math.random(),
        bookingDate: '2017-12-01',
    },
    {
        valuation: 100000,
        percentValue: Math.random(),
        bookingDate: '2018-01-01',
    },
];

const DUMMY_OBJECTIVE_VALUE = 100000;
module.exports = { DUMMY_DATA, DUMMY_OBJECTIVE_VALUE };
